import Const from 'const';
import LineupResolver, {MockLineupResolver, LateSwapLineupResolver} from './lineup-resolver';

const lineupResolverMap = {
    [Const.MODE_LATESWAP]: LateSwapLineupResolver,
};

export default function getLineupResolver(sportConfig): LineupResolver {
    const mode = sportConfig.getMode();

    if (mode in lineupResolverMap) {
        return new lineupResolverMap[mode]();
    }

    return new MockLineupResolver();
}
